import type { IMarkAreaTheme } from '@visactor/vchart';

export const markArea: IMarkAreaTheme = {
  label: {
    labelBackground: {
      padding: {
        top: 2,
        bottom: 2,
        right: 4,
        left: 4
      }
    }
  }
};
